import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {Observable, of} from 'rxjs';
import {AuthService} from '../auth.service';
import {switchMap} from 'rxjs/operators';
import {isWindowsOS} from '../helpers/kluh';

@Injectable()
export class HomeService {
    private history = [];

    constructor(private auth: AuthService, private router: Router) {
    }

    canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        return this.auth.isLoggedIn().pipe(switchMap((result) => {
            if (result) {
                return this.auth.getMyPermissions().pipe(switchMap((_permissions) => {
                    this.redirectDesktop();
                    return of(false);
                }));
            } else {
                this.auth.redirectToLogin(null);
                return of(false);
            }
        }));
    }

    private redirectDesktop(): void {
        if (!isWindowsOS()) {
            this.router.navigate(['webclient-html5']);
        } else {
            this.router.navigate(['desktop']);
        }
    }
}
